{
  "user-profile-page": {
    "meta": {
      "title": "Hồ sơ cá nhân",
      "description": "Thông tin người dùng"
    }
  }
}
